export default __webpack_public_path__ + "static/media/grades-annual.2ff74dfb.svg";